export default __webpack_public_path__ + "static/media/background-info.1717485a.svg";